import { useState, useEffect, useCallback } from "react";
import {
  FileDown,
  Plus,
  Send,
  Bell,
  RefreshCcw,
  Pen,
  Eye,
  UserPlus,
  Phone,
  Mail,
  Bike,
  BadgeCheck,
  Clock3,
  CalendarDays,
  LogIn,
  Package,
  Power,
  PowerOff,
  AlertTriangle,
  MapPin,
  CreditCard,
  Hash,
  Layers,
  FileBadge,
  Info,
} from "lucide-react";
import { exportAnyJsonToExcel } from "../Utils/exportAnyJsonToExcel";
import { Toaster, toast } from "sonner";
import { useGlobalContext } from "../../GlobalContext";
import AddDriverModal from "./AddDriverModal";
import LoadingScreen from "../Utils/LoadingScreen";
import * as Dialog from "@radix-ui/react-dialog";
import EditDriverModal from "./EditDriverModal";
import SendNotificationModal from "./SendNotificationModal";
import BulkSendNotificationModal from "./BulkSendNotificationModal";
import ViewKycDetails from "./ViewKycDetails";
import EditKycModal from "./EditKycModal";
import TablePagination from "../Utils/TablePagination";
import DriverConfigModal from "./DriverConfigModal";
import DriverDetailsModal from "./DriverDetailsModal";
import DriverConfigTable from "./DriverConfigTable";
import DriverConfigQuickAddModal from "./DriverConfigQuickAddModal";
import DriverChargesBoard from "./DriverChargesBoard";
import DriverChargesModal from "./DriverChargesModal";
import { useMemo } from "react";
import PrimaryTeamModal from "./PrimaryTeamModal";
import AssignTeamsModal from "./AssignTeamsModal";
import { useNavigate } from "react-router-dom";
import useDriver from "../../Sevices/Driver Api/useDriver";
import useDriverTeams from "../../Sevices/Driver Api/useDriverTeams";
import useDriverCharges from "../../Sevices/Driver Api/useDriverCharges";
import useDriverConfig from "../../Sevices/Driver Api/useDriverConfig";
import useDriverKYC from "../../Sevices/Driver Api/useDriverKYC";
import useNotification from "../../Sevices/useNotification";
import useKYCImageUpload from "../../Sevices/Driver Api/useKYCImageUpload";
import PackerTaskConfigModal from "./PackerTaskConfigModal";
import usePackerTaskConfig from "../../Sevices/Driver Api/usePackerTaskConfig";

export default function DriversPage() {
  const { baseurl, token, setIsUnauthorised, AdminId } = useGlobalContext();
  const navigate = useNavigate();
  const {
    drivers,
    loading,
    fetchDrivers,
    toggleDutyStatus,
    editDriverApi,
    updateDriverDutyApi,
    deactivateActivateDriverApi,
  } = useDriver();

  const {
    teams,
    teamsLoading,
    fetchDriverTeams,
    driverTeams,
    loadingTeams,
    fetchDriverMultipleTeams,
    updateDriverActiveTeam,
    insertDriverMultipleTeams,
    deleteDriverMultipleTeams,
  } = useDriverTeams();

  const {
    chargeRows,
    chargesLoading,
    fetchDriverCharges,
    getDriverChargesApi,
    saveDriverChargeApi,
  } = useDriverCharges();

  const {
    configRows,
    configLoading,
    fetchAllDriverConfigs,
    handleDeleteConfig,
    fetchDriverConfigByCode,
    fetchDriverConfigForQuickAdd,
    saveDriverQuickConfig,
    deleteDriverQuickConfig,
    fetchSingleDriverConfig,
    saveSingleDriverConfig,
    deleteSingleDriverConfig,
    deleteDriverConfig
  } = useDriverConfig();

 const {
   getPackerTaskConfig,
   savePackerTaskConfig,
   getAllPackerTask,
   updateDriverPackerStatus,
 } = usePackerTaskConfig();

  const {
    kycDrivers,
    fetchDriverKycDetails,
    handleKycAction,
    handleStepSubmit,
  } = useDriverKYC();

  const { uploadImageToServer } = useKYCImageUpload();
  const { sendNotification } = useNotification();

  const today = new Date();
  const todayDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1,
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth()); // 0-index
  const [Loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("list");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [bulkOpen, setBulkOpen] = useState(false);
  const [editKycModalOpen, setEditKycModalOpen] = useState(false);
  const [editDriver, setEditDriver] = useState(null);
  const [notificationDriver, setNotificationDriver] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [editKycDriver, setEditKycDriver] = useState(null);
  const [kycStatusLoading, setKycStatusLoading] = useState(false);
  const [openKycDialogId, setOpenKycDialogId] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [driverKycStatus, setDriverKycStatus] = useState(null);
  const [driverTabLoading, setDriverTabLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [kycFormdata, setKycFormData] = useState({
    driver_code: "",
    email: "",
    phone: "",
    aadhaar_no: "",
    pan_no: "",
    driving_licence: "",
    transport_type_id: "",
    transport_description: "",
    licence_plate: "",
    city: "",
    area: "",
    profile_photo: null,
    aadhaar_front: null,
    aadhaar_back: null,
    pan_front: null,
    driving_licence_img: null,
    vehicle_name_plate_img: null,
  });
  const [kycTabLoading, setKycTabLoading] = useState(false);
  const [configModalOpen, setConfigModalOpen] = useState(false);
  const [configDriverCode, setConfigDriverCode] = useState("");

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [detailsDriver, setDetailsDriver] = useState(null);
  const [statusConfirmOpen, setStatusConfirmOpen] = useState(false);
  const [statusDriver, setStatusDriver] = useState(null);
  const [statusSubmitting, setStatusSubmitting] = useState(false);

  const [deletingConfigId, setDeletingConfigId] = useState(null);
  const [configSearch, setConfigSearch] = useState("");
  const [quickConfigOpen, setQuickConfigOpen] = useState(false);
  const [chargesSearch, setChargesSearch] = useState("");
  const [chargesModalOpen, setChargesModalOpen] = useState(false);
  const [chargesDriverCode, setChargesDriverCode] = useState(""); // for edit-from-card

  const [teamSelectOpen, setTeamSelectOpen] = useState(false);
  const [selectedTeamIds, setSelectedTeamIds] = useState([]);
  const [teamDriverId, setTeamDriverId] = useState(null);
  const [assignTeamsOpen, setAssignTeamsOpen] = useState(false);
  const [primaryTeamOpen, setPrimaryTeamOpen] = useState(false);
  const [driverExistingTeams, setDriverExistingTeams] = useState([]);
  const [selectedDriverForTeams, setSelectedDriverForTeams] = useState(null);
  const [assignTeamDriverObj, setAssignTeamDriverObj] = useState(null);

const [packerTaskConfigOpen, setPackerTaskConfigOpen] = useState(false);
const [packerUpdatingId, setPackerUpdatingId] = useState(null);
const [packerStatusMap, setPackerStatusMap] = useState({});
const [packerTasks, setPackerTasks] = useState([]);
const [packerTasksLoading, setPackerTasksLoading] = useState(false);

const [packerTaskFilters, setPackerTaskFilters] = useState({
  driverId: "",
  fromDate: todayDate,
  toDate: todayDate,
});

  const driversPerPage = 25;
  const configPerPage = 15;
  const [configPage, setConfigPage] = useState(1);

  const selectedTeamDriverCodes = useMemo(() => {
    if (!selectedTeam) return null;

    const teamObj = teams.find((t) => t.team_name === selectedTeam)

    if (!teamObj || !Array.isArray(teamObj.driverlist)) return null;

    return new Set(teamObj.driverlist.map((d) => d.driver_code));
  }, [teams, selectedTeam]);

  const filteredDrivers = drivers.filter((driver) => {
    const matchSearch =
      driver.fullName?.toLowerCase().includes(search.toLowerCase()) ||
      driver.username?.toLowerCase().includes(search.toLowerCase());

    const matchTeam = selectedTeamDriverCodes
      ? selectedTeamDriverCodes.has(driver.driverId || driver.driver_code)
      : true;

    const matchStatus = selectedStatus
      ? driver.status === selectedStatus
      : true;

    return matchSearch && matchTeam && matchStatus;
  });

  const fetchPackerTasks = useCallback(async () => {
    try {
      setPackerTasksLoading(true);

      const data = await getAllPackerTask({
        driverId: packerTaskFilters.driverId,
        fromDate: packerTaskFilters.fromDate,
        toDate: packerTaskFilters.toDate,
      });

      setPackerTasks(Array.isArray(data) ? data : []);
    } finally {
      setPackerTasksLoading(false);
    }
  }, [getAllPackerTask, packerTaskFilters]);

useEffect(() => {
  const loadDriversTab = async () => {
    if (!AdminId) return;

    try {
      setDriverTabLoading(true);
      await Promise.all([
        fetchDrivers(true),
        fetchDriverTeams(),
      ]);
    } finally {
      setDriverTabLoading(false);
    }
  };

  loadDriversTab();
}, [AdminId]);

useEffect(() => {
  if (activeTab === "Packer Tasks") {
    fetchPackerTasks();
  }
}, [activeTab]);

  useEffect(() => {
    setConfigPage(1);
  }, [configSearch]);

  const filteredKycDrivers = kycDrivers?.filter((driver) => {
    const searchLower = search.toLowerCase();
    return [
      driver.name,
      driver.email,
      driver.driver_code,
      driver.aadhaar_no,
      driver.area,
      driver.city,
      driver.driving_licence,
      driver.licence_plate,
      driver.pan_no,
      driver.phone,
      driver.transport_description,
      driver.transport_type_id,
    ].some((field) => field?.toLowerCase().includes(searchLower));
  });

  const indexOfLast = currentPage * driversPerPage;
  const indexOfFirst = indexOfLast - driversPerPage;
  const currentDrivers = filteredDrivers?.slice(indexOfFirst, indexOfLast);
  const currentKycDrivers = filteredKycDrivers?.slice(
    indexOfFirst,
    indexOfLast,
  );
  const totalPages = Math.ceil(filteredDrivers?.length / driversPerPage);
  const totalKycPages = Math.ceil(filteredKycDrivers?.length / driversPerPage);

  // useEffect(() => {
  //   if (activeTab === "Kyc Details") fetchDriverKycDetails();
  // }, [activeTab]);

//   useEffect(() => {
//   if (activeTab === "Kyc Details" && AdminId) {
//     fetchAllDriverConfigs(true);
//     fetchDriverCharges();
//   }
// }, [activeTab, AdminId]);

  useEffect(() => {
    if (editKycDriver && editKycModalOpen) {
      setKycFormData({
        driver_code: editKycDriver.driverId || editKycDriver.driver_code || "",
        email: editKycDriver.email || "",
        phone: editKycDriver.phone || "",
        city: editKycDriver.city || "",
        area: editKycDriver.area || "",
        profile_photo:
          editKycDriver.profilePicture || editKycDriver.profile_photo || null,
        aadhaar_no:
          editKycDriver.aadharNumber || editKycDriver.aadhaar_no || "",
        aadhaar_front:
          editKycDriver.aadharFrontPhoto || editKycDriver.aadhaar_front || null,
        aadhaar_back:
          editKycDriver.aadharBackPhoto || editKycDriver.aadhaar_back || null,
        pan_no: editKycDriver.panCard || editKycDriver.pan_no || "",
        pan_front:
          editKycDriver.panCardFrontPhoto || editKycDriver.pan_front || null,
        driving_licence:
          editKycDriver.drivingLicenseNumber ||
          editKycDriver.driving_licence ||
          "",
        driving_licence_img:
          editKycDriver.drivingLicenseFrontPhoto ||
          editKycDriver.driving_licence_img ||
          null,
        transport_type_id:
          editKycDriver.transportTypeID ||
          editKycDriver.transport_type_id ||
          "",
        transport_description:
          editKycDriver.transportDescription ||
          editKycDriver.transport_description ||
          "",
        licence_plate:
          editKycDriver.licensePlate || editKycDriver.licence_plate || "",
        vehicle_name_plate_img:
          editKycDriver.licensePlatePhoto ||
          editKycDriver.vehicle_name_plate_img ||
          null,
      });
      setCurrentStep(1);
    }
  }, [editKycDriver, editKycModalOpen]);

  const handleEditKyc = (driverKycData) => {
    setEditKycDriver(driverKycData);
    setEditKycModalOpen(true);
  };

  const handleFileChange = (fieldName, file) => {
    setKycFormData((prev) => ({
      ...prev,
      [fieldName]: file,
    }));
  };

  const filteredConfigRows = (configRows || []).filter((r) => {
    const q = configSearch.trim().toLowerCase();
    if (!q) return true;

    return [
      r.driver_code,
      r.name,
      r.team_name,
      r.driver_type,
      String(r.cash_limit ?? ""),
      String(r.daily_task_limit ?? ""),
    ].some((v) =>
      String(v || "")
        .toLowerCase()
        .includes(q),
    );
  });

  const configIndexOfLast = configPage * configPerPage;
  const configIndexOfFirst = configIndexOfLast - configPerPage;
  const currentConfigRows = filteredConfigRows.slice(
    configIndexOfFirst,
    configIndexOfLast,
  );

  const handleDriverSelect = (e) => {
    const selectedDriverCode = e.target.value;
    const selectedDriver = drivers.find(
      (driver) => driver.driverId === selectedDriverCode,
    );

    if (selectedDriver) {
      setKycFormData((prev) => ({
        ...prev,
        driver_code: selectedDriverCode,
        email: selectedDriver.email || "",
        phone: selectedDriver.phone || "",
      }));
    } else {
      setKycFormData((prev) => ({
        ...prev,
        driver_code: "",
        email: "",
        phone: "",
      }));
    }
  };

  const resetForm = () => {
    setKycFormData({
      driver_code: "",
      email: "",
      phone: "",
      aadhaar_no: "",
      pan_no: "",
      driving_licence: "",
      transport_type_id: "",
      transport_description: "",
      licence_plate: "",
      city: "",
      area: "",
      profile_photo: null,
      aadhaar_front: null,
      aadhaar_back: null,
      pan_front: null,
      driving_licence_img: null,
      vehicle_name_plate_img: null,
    });
  };

  const closeKycModal = () => {
    setEditKycModalOpen(false);
    setEditKycDriver(null);
    setCurrentStep(1);
    resetForm();
  };

  const closeModel = () => {
    setOpenKycDialogId(null);
    setSelectedDriver(null);
    setDriverKycStatus(null);
  };

  const populateEditForm = (driver) => {
    setKycFormData({
      driver_code: driver.driver_code || "",
      email: driver.email || "",
      phone: driver.phone || "",
      aadhaar_no: driver.aadhaar_no || "",
      pan_no: driver.pan_no || "",
      driving_licence: driver.driving_licence || "",
      transport_type_id: driver.transport_type_id || "",
      transport_description: driver.transport_description || "",
      licence_plate: driver.licence_plate || "",
      city: driver.city || "",
      area: driver.area || "",
      profile_photo: driver.profile_photo || null,
      aadhaar_front: driver.aadhaar_front || null,
      aadhaar_back: driver.aadhaar_back || null,
      pan_front: driver.pan_front || null,
      driving_licence_img: driver.driving_licence_img || null,
      vehicle_name_plate_img: driver.vehicle_name_plate_img || null,
    });
    setEditKycModalOpen(true);
    setEditKycDriver(driver);
  };

  useEffect(() => {
    const loadKycDetails = async () => {
      if (activeTab !== "Kyc Details" || !AdminId) return;

      try {
        setKycTabLoading(true);
        await fetchDriverKycDetails();
      } finally {
        setKycTabLoading(false);
      }
    };

    loadKycDetails();
  }, [activeTab, AdminId]);

  useEffect(() => {
    if (activeTab === "Configuration" && AdminId) {
      fetchAllDriverConfigs();
    }
  }, [activeTab, AdminId]);

  const formatDateTime = (value) => {
    if (!value) return "-";
    try {
      const date = new Date(value);
      return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return value;
    }
  };

  const formatTaskDuration = (value) => {
    if (!value) return "-";

    const totalSeconds = Number(String(value).replace("s", ""));

    if (Number.isNaN(totalSeconds)) {
      return value;
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }

    return `${minutes}m ${seconds}s`;
  };

  const formatAmount = (value) => {
    const amount = Number(value);

    if (Number.isNaN(amount)) {
      return "₹0";
    }

    return amount.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    });
  };

  const getTaskStatusColor = (status) => {
    const normalizedStatus = String(status || "").toLowerCase();

    if (normalizedStatus === "completed" || normalizedStatus === "delivered") {
      return "bg-green-100 text-green-700";
    }

    if (normalizedStatus === "cancelled" || normalizedStatus === "rejected") {
      return "bg-red-100 text-red-700";
    }

    if (normalizedStatus === "assigned" || normalizedStatus === "accepted") {
      return "bg-blue-100 text-blue-700";
    }

    if (normalizedStatus === "in_progress" || normalizedStatus === "picked") {
      return "bg-purple-100 text-purple-700";
    }

    return "bg-orange-100 text-orange-700";
  };

  const InfoBadge = ({ children, color = "gray" }) => {
    const styles = {
      gray: "bg-gray-100 text-gray-600",
      blue: "bg-blue-100 text-blue-700",
      green: "bg-green-100 text-green-700",
      orange: "bg-orange-100 text-orange-700",
      red: "bg-red-100 text-red-700",
      purple: "bg-purple-100 text-purple-700",
    };

    return (
      <span
        className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${styles[color]}`}
      >
        {children}
      </span>
    );
  };

  const InfoPill = ({ children, color = "gray" }) => {
    const colors = {
      gray: "bg-gray-100 text-gray-700",
      green: "bg-green-100 text-green-700",
      blue: "bg-blue-100 text-blue-700",
      orange: "bg-orange-100 text-orange-700",
      purple: "bg-purple-100 text-purple-700",
      red: "bg-red-100 text-red-700",
    };

    return (
      <span
        className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${colors[color]}`}
      >
        {children}
      </span>
    );
  };

  const getDriverCode = (driver) =>
    String(driver?.driverId || driver?.driver_code || "").trim();

 const getDriverPackerStatus = (driver) => {
   const driverCode = getDriverCode(driver);

   // API update ke turant baad temporary local value
   if (Object.prototype.hasOwnProperty.call(packerStatusMap, driverCode)) {
     return packerStatusMap[driverCode];
   }

   // Actual driver-list API response
   const rawStatus =
     driver?.is_active_for_packer ??
     driver?.packer_status ??
     driver?.packerStatus ??
     driver?.is_packer ??
     driver?.isPacker ??
     "N";

   const normalizedStatus = String(rawStatus).trim().toUpperCase();

   return ["Y", "1", "TRUE", "ACTIVE"].includes(normalizedStatus) ? "Y" : "N";
 };

 const getAssignedTaskDriver = (task) => {
   const taskDriverId = task?.driver_id;

   if (
     taskDriverId === null ||
     taskDriverId === undefined ||
     taskDriverId === ""
   ) {
     return null;
   }

   return (
     drivers.find((driver) => {
       const possibleDriverIds = [
         driver?.id,
         driver?.pk_driver_id,
         driver?.driver_id,
         driver?.driverId,
         driver?.driver_code,
       ]
         .filter((value) => value !== null && value !== undefined)
         .map(String);

       return possibleDriverIds.includes(String(taskDriverId));
     }) || null
   );
 };

  const handlePackerStatusChange = async (driver) => {
    const driverCode = getDriverCode(driver);

    if (!driverCode || packerUpdatingId) return;

    const currentStatus = getDriverPackerStatus(driver);
    const nextStatus = currentStatus === "Y" ? "N" : "Y";

    try {
      setPackerUpdatingId(driverCode);

      const success = await updateDriverPackerStatus(driverCode, nextStatus);

      if (success) {
        setPackerStatusMap((previous) => ({
          ...previous,
          [driverCode]: nextStatus,
        }));

        await fetchDrivers(true);
      }
    } finally {
      setPackerUpdatingId(null);
    }
  };


  const renderDriversTable = () => (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead className="bg-orange-400 text-white border-b border-gray-200">
            <tr className="text-left">
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide">
                Driver
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide">
                Contact
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide">
                Vehicle / Shift
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide">
                Team / Type
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide">
                Status
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide">
                Packer
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide">
                Activity
              </th>
              <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 bg-white">
            {currentDrivers?.map((driver) => {
              const driverCode = getDriverCode(driver);
              const packerStatus = getDriverPackerStatus(driver);
              const isPacker = packerStatus === "Y";
              const isPackerUpdating = packerUpdatingId === driverCode;

              return (
                <tr
                  key={driver.id}
                  className="align-top transition-colors duration-200 hover:bg-orange-50/40"
                >
                  {/* Driver */}
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3 min-w-0">
                      <img
                        src={driver.profile_photo || "/placeholder-driver.png"}
                        alt={driver.fullName}
                        onError={(e) => {
                          e.currentTarget.src =
                            "https://ui-avatars.com/api/?name=" +
                            encodeURIComponent(driver.fullName || "Driver") +
                            "&background=F3F4F6&color=374151";
                        }}
                        className="h-11 w-11 rounded-xl border border-gray-200 object-cover shrink-0"
                      />

                      <div className="min-w-0">
                        <div
                          className="flex items-center gap-2 flex-wrap"
                          onClick={() => {
                            const driverId = driver.driverId;
                            const username = encodeURIComponent(
                              driver.fullName || driver.driverId,
                            );
                            const monthStart = `${year}-${String(month + 1).padStart(2, "0")}-01`;
                            const todayDate = new Date()
                              .toISOString()
                              .split("T")[0];

                            navigate(`/analytics/${driverId}/${username}`, {
                              state: {
                                fromDate: monthStart,
                                toDate: todayDate,
                              },
                            });
                          }}
                        >
                          <p className="text-sm font-semibold text-gray-900 leading-none truncate cursor-pointer underline">
                            {driver.fullName || "-"}
                          </p>
                          <InfoBadge color="blue">
                            {driver.driverId || "-"}
                          </InfoBadge>
                        </div>

                        <p className="mt-1 text-xs text-gray-500 truncate">
                          @{driver.username || "-"}
                        </p>
                      </div>
                    </div>
                  </td>

                  {/* Contact */}
                  <td className="px-4 py-3">
                    <div className="space-y-1 text-xs text-gray-700">
                      <div className="flex items-center gap-2 min-w-0">
                        <Phone size={13} className="text-gray-400 shrink-0" />
                        <span className="truncate">{driver.phone || "-"}</span>
                      </div>

                      <div className="flex items-center gap-2 min-w-0">
                        <Mail size={13} className="text-gray-400 shrink-0" />
                        <span className="truncate">{driver.email || "-"}</span>
                      </div>
                    </div>
                  </td>

                  {/* Vehicle / Shift */}
                  <td className="px-4 py-3">
                    <div className="space-y-1 text-xs text-gray-700">
                      <div className="flex items-center gap-2 min-w-0">
                        <Bike size={13} className="text-gray-400 shrink-0" />
                        <span className="truncate">
                          {driver.transport_type || "-"}
                          {driver.transport_description
                            ? ` • ${driver.transport_description}`
                            : ""}
                        </span>
                      </div>

                      <div className="flex items-center gap-2 min-w-0">
                        <BadgeCheck
                          size={13}
                          className="text-gray-400 shrink-0"
                        />
                        <span className="truncate">
                          {driver.licence_plate || "-"}
                        </span>
                      </div>

                      <div className="flex items-center gap-2 min-w-0">
                        <Clock3 size={13} className="text-gray-400 shrink-0" />
                        <span>
                          {driver.shift_start || "-"} -{" "}
                          {driver.shift_end || "-"}
                        </span>
                      </div>
                    </div>
                  </td>

                  {/* Team / Type */}
                  <td className="px-4 py-3">
                    <div className="flex flex-wrap gap-1.5">
                      <InfoBadge color="orange">
                        {driver.teamName || "Unassigned"}
                      </InfoBadge>
                      <InfoBadge color="green">
                        {driver.driver_type || "N/A"}
                      </InfoBadge>
                      <InfoBadge color="purple">
                        {driver.tier || "N/A"}
                      </InfoBadge>
                    </div>
                  </td>

                  {/* Status */}
                  <td className="px-4 py-3">
                    <div className="flex flex-col gap-2">
                      <div className="flex items-center gap-2">
                        <label
                          className={`relative inline-flex items-center ${
                            loading
                              ? "opacity-60 pointer-events-none"
                              : "cursor-pointer"
                          }`}
                        >
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={driver.dutyStatus === "active"}
                            onChange={() =>
                              toggleDutyStatus(
                                driver,
                                driver.dutyStatus === "active",
                              )
                            }
                            disabled={loading}
                          />
                          <div className="h-5 w-9 rounded-full bg-gray-300 transition-colors peer-checked:bg-green-500" />
                          <span className="absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform peer-checked:translate-x-4" />
                        </label>

                        <span className="text-[11px] font-medium text-gray-600">
                          {driver.dutyStatus === "active"
                            ? "On duty"
                            : "Off duty"}
                        </span>
                      </div>

                      <div>
                        <InfoBadge
                          color={driver.status === "active" ? "green" : "red"}
                        >
                          {driver.status || "-"}
                        </InfoBadge>
                      </div>
                    </div>
                  </td>

                  {/* Packer Status */}
                  <td className="px-4 py-3">
                    <div className="flex flex-col gap-1.5">
                      <button
                        type="button"
                        onClick={() => handlePackerStatusChange(driver)}
                        disabled={isPackerUpdating || !driverCode}
                        title={isPacker ? "Disable Packer" : "Enable Packer"}
                        className={`relative h-5 w-9 rounded-full transition-colors ${
                          isPacker ? "bg-orange-500" : "bg-gray-300"
                        } ${
                          isPackerUpdating
                            ? "cursor-not-allowed opacity-60"
                            : "cursor-pointer"
                        }`}
                      >
                        <span
                          className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition-all ${
                            isPacker ? "left-4" : "left-0.5"
                          }`}
                        />
                      </button>

                      <span
                        className={`text-[11px] font-medium ${
                          isPacker ? "text-orange-600" : "text-gray-500"
                        }`}
                      >
                        {isPackerUpdating
                          ? "Updating..."
                          : isPacker
                            ? "Packer"
                            : "Not Packer"}
                      </span>
                    </div>
                  </td>

                  {/* Activity */}
                  <td className="px-4 py-3">
                    <div className="space-y-1 text-xs text-gray-700">
                      <div className="flex items-center gap-2">
                        <CalendarDays
                          size={13}
                          className="text-gray-400 shrink-0"
                        />
                        <span className="truncate">
                          {formatDateTime(driver.joiningDate)}
                        </span>
                      </div>

                      <div className="flex items-center gap-2">
                        <LogIn size={13} className="text-gray-400 shrink-0" />
                        <span className="truncate">
                          {formatDateTime(driver.last_login)}
                        </span>
                      </div>
                    </div>
                  </td>

                  {/* Actions */}
                  <td className="px-4 py-3">
                    <div className="flex items-center justify-center gap-1.5">
                      <button
                        className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-white text-green-600 transition hover:bg-green-50"
                        onClick={() => {
                          setNotificationDriver(driver);
                          setNotificationModalOpen(true);
                        }}
                        title="Notifications"
                      >
                        <Bell size={14} />
                      </button>

                      <button
                        className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-700 transition hover:bg-gray-50"
                        onClick={() => {
                          setDetailsDriver(driver);
                          setDetailsModalOpen(true);
                        }}
                        title="Driver Details"
                      >
                        <Info size={14} />
                      </button>
                      <button
                        className={`inline-flex h-8 w-8 items-center justify-center rounded-lg border bg-white transition ${
                          driver.status === "active"
                            ? "border-red-200 text-red-600 hover:bg-red-50"
                            : "border-green-200 text-green-600 hover:bg-green-50"
                        }`}
                        onClick={() => {
                          setStatusDriver(driver);
                          setStatusConfirmOpen(true);
                        }}
                        title={
                          driver.status === "active"
                            ? "Deactivate Driver"
                            : "Activate Driver"
                        }
                      >
                        {driver.status === "active" ? (
                          <PowerOff size={14} />
                        ) : (
                          <Power size={14} />
                        )}
                      </button>

                      <button
                        className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-white text-blue-600 transition hover:bg-blue-50"
                        onClick={() => {
                          setSelectedDriverForTeams(driver.driverId);
                          setAssignTeamDriverObj(driver);
                          setAssignTeamsOpen(true);
                        }}
                        title="Assign Teams"
                      >
                        <UserPlus size={14} />
                      </button>
                      <button
                        className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-white text-orange-600 transition hover:bg-orange-50"
                        onClick={() =>
                          navigate(`/drivers/orders/${driver.driverId}`, {
                            state: { driver },
                          })
                        }
                        title="View Driver Orders"
                      >
                        <Package size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  const KycBadge = ({ children, color = "gray" }) => {
    const styles = {
      gray: "bg-gray-100 text-gray-600",
      green: "bg-green-100 text-green-700",
      yellow: "bg-yellow-100 text-yellow-700",
      red: "bg-red-100 text-red-700",
      blue: "bg-blue-100 text-blue-700",
      orange: "bg-orange-100 text-orange-700",
      purple: "bg-purple-100 text-purple-700",
    };

    return (
      <span
        className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${styles[color]}`}
      >
        {children}
      </span>
    );
  };

  const getKycStatusColor = (status) => {
    if (status === "Approved") return "green";
    if (status === "Rejected") return "red";
    return "yellow";
  };

  const renderKycTable = () => (
    <div className="w-full min-w-0 overflow-hidden rounded-2xl border shadow-sm">
      <div className="w-full min-w-0 overflow-x-auto">
        <table className="w-full table-fixed">
          <thead className="border-b border-gray-200 bg-orange-400 text-white">
            <tr>
              <th className="w-[21%] px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                Driver
              </th>

              <th className="w-[20%] px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                KYC Details
              </th>

              <th className="w-[16%] px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                Vehicle
              </th>

              <th className="w-[35%] px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                Location / Status
              </th>

              <th className="w-[8%] px-2 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 bg-white">
            {currentKycDrivers?.map((driver, index) => (
              <tr
                key={driver.driver_code || driver.id}
                className="text-sm transition hover:bg-gray-50"
              >
                {/* S/N */}

                {/* Driver */}
                <td className="px-4 py-3">
                  <div className="flex items-center gap-3 min-w-0">
                    <img
                      src={driver.profile_photo || "/placeholder-driver.png"}
                      alt={driver.name || "Driver"}
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://ui-avatars.com/api/?name=" +
                          encodeURIComponent(driver.name || "Driver") +
                          "&background=F3F4F6&color=374151";
                      }}
                      className="h-11 w-11 rounded-xl border border-gray-200 object-cover shrink-0"
                    />

                    <div className="min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <p className="truncate text-sm font-semibold text-gray-900">
                          {driver.name || "N/A"}
                        </p>
                        <KycBadge color="blue">
                          {driver.driver_code || "N/A"}
                        </KycBadge>
                      </div>

                      <div className="mt-1 space-y-1 text-xs text-gray-600">
                        <div className="flex items-center gap-2 min-w-0">
                          <Phone size={13} className="shrink-0 text-gray-400" />
                          <span className="truncate">
                            {driver.phone || "N/A"}
                          </span>
                        </div>

                        <div className="flex items-center gap-2 min-w-0">
                          <Mail size={13} className="shrink-0 text-gray-400" />
                          <span className="truncate">
                            {driver.email || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                {/* KYC Details */}
                <td className="px-4 py-3">
                  <div className="space-y-1 text-xs text-gray-700">
                    <div className="flex items-center gap-2 min-w-0">
                      <CreditCard
                        size={13}
                        className="shrink-0 text-gray-400"
                      />
                      <span className="font-medium text-gray-500">
                        Aadhaar:
                      </span>
                      <span className="truncate">
                        {driver.aadhaar_no || "N/A"}
                      </span>
                    </div>

                    <div className="flex items-center gap-2 min-w-0">
                      <FileBadge size={13} className="shrink-0 text-gray-400" />
                      <span className="font-medium text-gray-500">PAN:</span>
                      <span className="truncate">{driver.pan_no || "N/A"}</span>
                    </div>

                    <div className="flex items-center gap-2 min-w-0">
                      <BadgeCheck
                        size={13}
                        className="shrink-0 text-gray-400"
                      />
                      <span className="font-medium text-gray-500">DL:</span>
                      <span className="truncate">
                        {driver.driving_licence || "N/A"}
                      </span>
                    </div>
                  </div>
                </td>

                {/* Vehicle */}
                <td className="px-4 py-3">
                  <div className="space-y-1 text-xs text-gray-700">
                    <div className="flex items-center gap-2 min-w-0">
                      <Bike size={13} className="shrink-0 text-gray-400" />
                      <span className="truncate">
                        {driver.transport_type_id || "N/A"}
                        {driver.transport_description
                          ? ` • ${driver.transport_description}`
                          : ""}
                      </span>
                    </div>

                    <div className="flex items-center gap-2 min-w-0">
                      <Hash size={13} className="shrink-0 text-gray-400" />
                      <span className="truncate">
                        {driver.licence_plate || "N/A"}
                      </span>
                    </div>
                  </div>
                </td>

                {/* Location / Status */}
                <td className="px-4 py-3">
                  <div className="space-y-2">
                    <div className="space-y-1 text-xs text-gray-700">
                      <div className="flex min-w-0 items-start gap-2">
                        <MapPin
                          size={13}
                          className="mt-0.5 shrink-0 text-gray-400"
                        />

                        <span
                          className="line-clamp-2 min-w-0 break-words leading-4"
                          title={`${driver.city || "N/A"}${
                            driver.area ? ` • ${driver.area}` : ""
                          }`}
                        >
                          {driver.city || "N/A"}
                          {driver.area ? ` • ${driver.area}` : ""}
                        </span>
                      </div>   

                      {!!driver.current_step && (
                        <div className="flex items-center gap-2 min-w-0">
                          <Layers
                            size={13}
                            className="shrink-0 text-gray-400"
                          />
                          <span className="truncate">
                            Step {driver.current_step}
                          </span>
                        </div>
                      )}
                    </div>

                    <KycBadge color={getKycStatusColor(driver.status)}>
                      {driver.status || "Pending"}
                    </KycBadge>
                  </div>
                </td>

                {/* Actions */}
                <td className="px-4 py-3 text-center">
                  <div className="flex items-center justify-center gap-1.5">
                    <button
                      className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 transition hover:bg-gray-50 hover:text-gray-800"
                      title="Show Details"
                      onClick={() => {
                        setSelectedDriver(driver);
                        setOpenKycDialogId(driver.id || driver.driver_code);
                      }}
                    >
                      <Eye size={15} />
                    </button>

                    <button
                      className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-white text-blue-600 transition hover:bg-blue-50 hover:text-blue-700"
                      title="Edit KYC"
                      onClick={() => {
                        setEditKycDriver(driver);
                        populateEditForm(driver);
                        setEditKycModalOpen(true);
                      }}
                    >
                      <Pen size={14} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderTabNavigation = () => (
    <div className="mb-4 border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        <button
          onClick={() => setActiveTab("list")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === "list"
              ? "border-orange-600 text-orange-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Driver
        </button>
        <button
          onClick={() => setActiveTab("Kyc Details")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === "Kyc Details"
              ? "border-orange-600 text-orange-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Kyc Details
        </button>
        <button
          onClick={() => setActiveTab("Configuration")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === "Configuration"
              ? "border-orange-600 text-orange-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Configuration
        </button>
        <button
          onClick={() => setActiveTab("Packer Tasks")}
          className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
            activeTab === "Packer Tasks"
              ? "border-orange-600 text-orange-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Packer Tasks
        </button>
      </nav>
    </div>
  );

  const renderSearchAndFilters = () => (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
      <div className="flex flex-wrap items-end gap-2">
        {activeTab !== "Configuration" ? (
          <input
            // type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={
              activeTab === "Kyc Details"
                ? "Search by email or drive code..."
                : "Search name or username..."
            }
            className="px-2 py-1 border rounded text-xs shadow-sm w-[220px]"
            autoComplete="off"
          />
        ) : (
          <input
            type="text"
            value={configSearch}
            onChange={(e) => setConfigSearch(e.target.value)}
            placeholder="Search config by driver code, name, team..."
            className="px-2 py-1 border rounded text-xs shadow-sm w-[220px]"
            autoComplete="off"
          />
        )}
      </div>

      {activeTab === "list" && renderDriverActions()}
      {activeTab === "Kyc Details" && renderKycActions()}

      {activeTab === "Configuration" && (
        <div className="flex flex-wrap items-end gap-2">
          <button
            className="flex items-center space-x-1 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => {
              setChargesDriverCode("");
              setChargesModalOpen(true);
            }}
          >
            <Plus size={14} />
            <span>Add Charges</span>
          </button>

          <button
            className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => setQuickConfigOpen(true)}
          >
            <Plus size={14} />
            <span>Add Config</span>
          </button>

          <button
            className="flex items-center space-x-1 bg-orange-500 hover:bg-orange-600 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => setPackerTaskConfigOpen(true)}
          >
            <Plus size={14} />
            <span>Task Config</span>
          </button>

          <button
            className="flex items-center space-x-1 bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => fetchAllDriverConfigs()}
          >
            <RefreshCcw size={14} />
            <span>Refresh</span>
          </button>
        </div>
      )}
    </div>
  );

  const renderDriverActions = () => (
    <div className="flex flex-wrap items-end gap-2">
      <select
        className="text-xs border rounded px-2 py-1 shadow-sm w-[130px]"
        value={selectedTeam}
        onChange={(e) => setSelectedTeam(e.target.value)}
      >
        <option value="">All Teams</option>
        {teams?.map((team) => (
          <option key={team.id} value={team.team_name}>
            {team.team_name}
          </option>
        ))}
      </select>

      <select
        className="text-xs border rounded px-2 py-1 shadow-sm w-[130px]"
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
      >
        <option value="">All Status</option>
        <option value="active">Active</option>
        <option value="offline">Offline</option>
      </select>

      <button
        className="flex items-center space-x-1 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() =>
          exportAnyJsonToExcel({
            data: drivers,
            filePrefix: "DriversExport",
            sheetName: "DriversList",
          })
        }
      >
        <FileDown size={14} />
        <span>Export</span>
      </button>

      <button
        className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => setModalOpen(true)}
      >
        <Plus size={14} />
        <span>Add Driver</span>
      </button>

      <button
        className="flex items-center space-x-1 bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => setBulkOpen(true)}
      >
        <Send size={14} />
        <span>Send Bulk</span>
      </button>

      {/* <button className="flex items-center space-x-1 bg-orange-500 hover:bg-orange-600 text-white px-3 py-1.5 rounded text-xs shadow">
        <Bell size={14} />
        <span>Push</span>
      </button> */}

     <button
  className="flex items-center space-x-1 bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded text-xs shadow"
  onClick={async () => {
    try {
      setDriverTabLoading(true);
      await fetchDrivers(true);
    } finally {
      setDriverTabLoading(false);
    }
  }}
>
        <RefreshCcw size={14} />
        <span>Refresh</span>
      </button>
    </div>
  );

  const renderKycActions = () => (
    <div className="flex flex-wrap items-end gap-2">
      <button
        className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => {
          setEditKycDriver(null);
          resetForm();
          setCurrentStep(1);
          setEditKycModalOpen(true);
        }}
      >
        <Plus size={14} />
        <span>Add KYC</span>
      </button>
    </div>
  );

  const renderPagination = () => {
    const totalCount =
      activeTab === "list"
        ? filteredDrivers?.length || 0
        : filteredKycDrivers?.length || 0;

    return (
      <TablePagination
        currentPage={currentPage}
        totalCount={totalCount}
        pageSize={driversPerPage}
        onPageChange={setCurrentPage}
      />
    );
  };

  const renderModals = () => {
    const isAnyModalOpen =
      modalOpen ||
      editModalOpen ||
      statusConfirmOpen ||
      notificationModalOpen ||
      bulkOpen ||
      editKycModalOpen ||
      !!selectedDriver ||
      configModalOpen ||
      detailsModalOpen ||
      quickConfigOpen ||
      packerTaskConfigOpen ||
      chargesModalOpen ||
      teamSelectOpen ||
      assignTeamsOpen ||
      primaryTeamOpen;

    if (!isAnyModalOpen) return null;

    return (
      <>

        <AddDriverModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          Refesh={fetchDrivers}
          AdminId={AdminId}
        />
        <EditDriverModal
          isOpen={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          driver={editDriver}
          teams={teams}
          onDriverUpdated={() => fetchDrivers()}
          editDriverApi={editDriverApi}
          updateDriverDutyApi={updateDriverDutyApi}
        />

        <AssignTeamsModal
          isOpen={assignTeamsOpen}
          onClose={() => setAssignTeamsOpen(false)}
          driverId={selectedDriverForTeams}
          teams={teams}
          driver={assignTeamDriverObj}
          fetchDriverMultipleTeams={fetchDriverMultipleTeams}
          updateDriverActiveTeam={updateDriverActiveTeam}
          deleteDriverMultipleTeams={deleteDriverMultipleTeams}
          onNext={(driverId, teamIds, existingTeams) => {
            setSelectedDriverForTeams(driverId);
            setTeamDriverId(driverId);
            setSelectedTeamIds(teamIds);
            setDriverExistingTeams(existingTeams);
            setAssignTeamsOpen(false);
            setPrimaryTeamOpen(true);
          }}
        />

        <PrimaryTeamModal
          isOpen={primaryTeamOpen}
          onClose={() => {
            setPrimaryTeamOpen(false);
            setSelectedTeamIds([]);
            setDriverExistingTeams([]);
            setSelectedDriverForTeams(null);
            setTeamDriverId(null);
          }}
          selectedTeams={(() => {
            const apiTeamsMap = new Map(
              driverExistingTeams.map((t) => [
                String(t.teamId || t.team_id || t.id).trim(),
                {
                  id: String(t.teamId || t.team_id || t.id).trim(),
                  teamId: t.teamId || t.team_id || t.id,
                  team_name: t.teamName || t.team_name,
                  teamName: t.teamName || t.team_name,
                  isPrimary: t.isPrimary,
                  isActive: t.isActive,
                },
              ]),
            );

            const newlySelectedTeams = teams
              .filter((t) => {
                const sid = String(t.id).trim();
                return selectedTeamIds.includes(sid) && !apiTeamsMap.has(sid);
              })
              .map((t) => ({
                id: String(t.id).trim(),
                teamId: t.id,
                team_name: t.team_name || t.teamName,
                teamName: t.team_name || t.teamName,
                isPrimary: "N",
                isActive: "Y",
              }));

            const allSelectedTeams = [
              ...Array.from(apiTeamsMap.values()),
              ...newlySelectedTeams,
            ];

            return allSelectedTeams;
          })()}
          onConfirm={async (primaryId) => {
            if (!teamDriverId) {
              toast.error("Driver ID missing!");
              console.error(" teamDriverId is null or undefined");
              return;
            }

            const success = await insertDriverMultipleTeams({
              driverId: teamDriverId,
              adminId: AdminId,
              teamIds: selectedTeamIds,
              primaryTeamId: primaryId,
            });

            if (success) {
              setPrimaryTeamOpen(false);
              await new Promise((resolve) => setTimeout(resolve, 500));

              // Refresh driver teams
              const updatedTeams = await fetchDriverMultipleTeams(teamDriverId);

              // Update state
              setDriverExistingTeams(updatedTeams);
              await fetchDrivers(true);
              await fetchDriverTeams();

              // Reset
              setSelectedTeamIds([]);
              setDriverExistingTeams([]);
              setSelectedDriverForTeams(null);
              setTeamDriverId(null);

              toast.success("Teams assigned successfully!");
            }
          }}
        />

        <SendNotificationModal
          isOpen={notificationModalOpen}
          onClose={() => setNotificationModalOpen(false)}
          driver={notificationDriver}
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          AdminId={AdminId}
          sendSingleNotificationApi={sendNotification}
        />

        <BulkSendNotificationModal
          isOpen={bulkOpen}
          onClose={() => setBulkOpen(false)}
          drivers={drivers}
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          AdminId={AdminId}
        />

        <EditKycModal
          editKycModalOpen={editKycModalOpen}
          setEditKycModalOpen={setEditKycModalOpen}
          editKycDriver={editKycDriver}
          setEditKycDriver={setEditKycDriver}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          kycFormdata={kycFormdata}
          setKycFormData={setKycFormData}
          drivers={drivers}
          handleDriverSelect={handleDriverSelect}
          handleFileChange={handleFileChange}
          handleStepSubmit={handleStepSubmit}
          uploadImageToServer={uploadImageToServer}
          resetForm={resetForm}
          Loading={Loading}
          onSuccess={() => {
            if (activeTab === "Kyc Details") {
              fetchDriverKycDetails();
            }
          }}
          activeTab={activeTab}
          FetchDriverKycDetails={fetchDriverKycDetails}
          AdminId={AdminId}
        />

        <ViewKycDetails
          selectedDriver={selectedDriver}
          setSelectedDriver={setSelectedDriver}
          driverKycStatus={driverKycStatus}
          setDriverKycStatus={setDriverKycStatus}
          previewImage={previewImage}
          setPreviewImage={setPreviewImage}
          loading={loading}
          setLoading={setLoading}
          kycStatusLoading={kycStatusLoading}
          setKycStatusLoading={setKycStatusLoading}
          openKycDialogId={openKycDialogId}
          setOpenKycDialogId={setOpenKycDialogId}
          closeModel={closeModel}
          activeTab={activeTab}
          kycFormdata={editKycDriver || {}}
          resetForm={resetForm}
          setEditKycModalOpen={setEditKycModalOpen}
          setEditKycDriver={setEditKycDriver}
          setCurrentStep={setCurrentStep}
          updateDriverKycStatus={handleKycAction}
          fetchDriverKycDetails={fetchDriverKycDetails}
          handleStepSubmit={handleStepSubmit}
          configRows={configRows}
          chargeRows={chargeRows}
          AdminId={AdminId}
        />

        <DriverConfigModal
          open={configModalOpen}
          onOpenChange={setConfigModalOpen}
          driverCode={configDriverCode}
          onSuccess={() => {
            if (activeTab === "Configuration") fetchAllDriverConfigs(true);
          }}
          fetchSingleDriverConfig={fetchSingleDriverConfig}
          saveSingleDriverConfig={saveSingleDriverConfig}
          deleteSingleDriverConfig={deleteDriverConfig}
        />

        <DriverDetailsModal
          open={detailsModalOpen}
          onOpenChange={setDetailsModalOpen}
          driver={detailsDriver}
          fetchDriverConfigByCode={fetchDriverConfigByCode}
          onOpenConfig={(driverCode) => {
            setConfigDriverCode(driverCode);
            setConfigModalOpen(true);
          }}
          onEditDriver={(driverObj) => {
            setDetailsModalOpen(false);
            setEditDriver(driverObj);
            setEditModalOpen(true);
          }}
          onToggleDutyStatus={async (driverObj, isCurrentlyOn) => {
            await toggleDutyStatus(driverObj, isCurrentlyOn);

            setDetailsDriver((prev) =>
              prev
                ? {
                    ...prev,
                    dutyStatus: isCurrentlyOn ? "inactive" : "active",
                  }
                : prev,
            );
          }}
          dutyLoading={loading}
        />

        <DriverConfigQuickAddModal
          open={quickConfigOpen}
          onOpenChange={setQuickConfigOpen}
          drivers={drivers}
          onSuccess={() => fetchAllDriverConfigs(true)}
          fetchDriverConfigForQuickAdd={fetchDriverConfigForQuickAdd}
          saveDriverQuickConfig={saveDriverQuickConfig}
          deleteDriverQuickConfig={deleteDriverQuickConfig}
        />

        <DriverChargesModal
          open={chargesModalOpen}
          onOpenChange={setChargesModalOpen}
          adminId={AdminId}
          drivers={drivers}
          initialDriverCode={chargesDriverCode}
          onSuccess={() => fetchDriverCharges()}
        />
      </>
    );
  };
  
  useEffect(() => {
    if (activeTab === "Driver Charges") fetchDriverCharges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const filteredChargesRows = (chargeRows || []).filter((r) => {
    const q = chargesSearch.trim().toLowerCase();
    if (!q) return true;

    return [
      r.driverCode,
      r.name,
      r.teamName,
      String(r.per_day?.amount ?? ""),
      String(r.per_order?.amount ?? ""),
    ].some((v) =>
      String(v || "")
        .toLowerCase()
        .includes(q),
    );
  });

  return (
    <div className="p-4">
      <Toaster position="top-right" />

      <div className="flex justify-between items-center">
        <h1 className="text-xl font-semibold">Drivers</h1>
      </div>

      {renderTabNavigation()}
      {renderSearchAndFilters()}

      <>
        {activeTab === "list" &&
          (driverTabLoading || loading ? (
            <LoadingScreen />
          ) : (
            renderDriversTable()
          ))}

        {activeTab === "Kyc Details" &&
          (kycTabLoading ? <LoadingScreen /> : renderKycTable())}

        {activeTab === "Configuration" &&
          (configLoading ? (
            <LoadingScreen />
          ) : (
            <>
              <DriverConfigTable
                rows={currentConfigRows}
                deletingId={deletingConfigId}
                onEdit={(driverCode) => {
                  setConfigDriverCode(driverCode);
                  setConfigModalOpen(true);
                }}
                onDelete={handleDeleteConfig}
              />

              <TablePagination
                currentPage={configPage}
                totalCount={filteredConfigRows.length}
                pageSize={configPerPage}
                onPageChange={setConfigPage}
              />
            </>
          ))}

        {activeTab === "Driver Charges" &&
          (chargesLoading ? (
            <LoadingScreen />
          ) : (
            <DriverChargesBoard
              rows={filteredChargesRows}
              onEditDriver={(driverCode) => {
                setChargesDriverCode(driverCode);
                setChargesModalOpen(true);
              }}
            />
          ))}

        {activeTab === "list" &&
          !driverTabLoading &&
          !loading &&
          renderPagination()}
        {activeTab === "Kyc Details" && !kycTabLoading && renderPagination()}

        {activeTab === "Packer Tasks" && (
          <div className="space-y-4">
            {/* Filters */}
            <div className="flex flex-wrap items-end gap-3 rounded-xl border bg-white p-4 shadow-sm">
              <div>
                <label className="mb-1 block text-xs font-medium text-gray-600">
                  Driver
                </label>

                <select
                  value={packerTaskFilters.driverId}
                  onChange={(e) =>
                    setPackerTaskFilters((prev) => ({
                      ...prev,
                      driverId: e.target.value,
                    }))
                  }
                  className="min-w-[210px] rounded-lg border px-3 py-2 text-xs outline-none focus:border-orange-500"
                >
                  <option value="">All Drivers</option>

                  {drivers.map((driver) => {
                    const code = driver?.driverId || driver?.driver_code || "";

                    const name =
                      driver?.fullName ||
                      driver?.name ||
                      driver?.username ||
                      code;

                    return (
                      <option key={code} value={code}>
                        {name} ({code})
                      </option>
                    );
                  })}
                </select>
              </div>

              <div>
                <label className="mb-1 block text-xs font-medium text-gray-600">
                  From Date
                </label>

                <input
                  type="date"
                  value={packerTaskFilters.fromDate}
                  onChange={(e) =>
                    setPackerTaskFilters((prev) => ({
                      ...prev,
                      fromDate: e.target.value,
                    }))
                  }
                  className="rounded-lg border px-3 py-2 text-xs outline-none focus:border-orange-500"
                />
              </div>

              <div>
                <label className="mb-1 block text-xs font-medium text-gray-600">
                  To Date
                </label>

                <input
                  type="date"
                  value={packerTaskFilters.toDate}
                  min={packerTaskFilters.fromDate || undefined}
                  onChange={(e) =>
                    setPackerTaskFilters((prev) => ({
                      ...prev,
                      toDate: e.target.value,
                    }))
                  }
                  className="rounded-lg border px-3 py-2 text-xs outline-none focus:border-orange-500"
                />
              </div>

              <button
                type="button"
                onClick={fetchPackerTasks}
                disabled={packerTasksLoading}
                className="rounded-lg bg-orange-500 px-4 py-2 text-xs font-medium text-white hover:bg-orange-600 disabled:opacity-60"
              >
                {packerTasksLoading ? "Searching..." : "Search Tasks"}
              </button>
            </div>

            {/* Task Table */}
            {packerTasksLoading ? (
              <LoadingScreen />
            ) : (
              <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
                <div className="overflow-x-auto">
                  <table className="min-w-[1250px] w-full">
                    <thead className="bg-orange-400 text-white">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                          Parcel
                        </th>

                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                          Sender
                        </th>

                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                          Receiver
                        </th>

                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                          Trip
                        </th>

                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                          Fare
                        </th>

                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                          Task Status
                        </th>

                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                          Driver
                        </th>

                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                          Created
                        </th>
                      </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100 bg-white">
                      {packerTasks.length > 0 ? (
                        packerTasks.map((task, index) => {
                          const parcelId =
                            task?.pk_parcel_id || `parcel-${index}`;

                          const driverAssigned =
                            task?.driver_id !== null &&
                            task?.driver_id !== undefined &&
                            task?.driver_id !== "";

                          const assignedDriver = getAssignedTaskDriver(task);

                          const isActiveForPacker =
                            String(
                              assignedDriver?.is_active_for_packer || "N",
                            ).toUpperCase() === "Y";

                          const packerTeamId =
                            assignedDriver?.packer_team_id ?? 0;

                          return (
                            <tr
                              key={parcelId}
                              className="align-top transition-colors hover:bg-orange-50/40"
                            >
                              {/* Parcel */}
                              <td className="px-4 py-3">
                                <div className="space-y-1">
                                  <div className="text-sm font-semibold text-gray-900">
                                    #{task?.pk_parcel_id || "-"}
                                  </div>

                                  <div className="text-xs text-gray-500">
                                    Customer: {task?.customer_id || "-"}
                                  </div>

                                  <div className="text-xs text-gray-500">
                                    Vehicle: {task?.vehicle_id || "-"}
                                  </div>
                                </div>
                              </td>

                              {/* Sender */}
                              <td className="px-4 py-3">
                                <div className="space-y-1">
                                  <div className="text-sm font-medium text-gray-900">
                                    {task?.sender_name || "-"}
                                  </div>

                                  <div className="flex items-center gap-1.5 text-xs text-gray-600">
                                    <Phone
                                      size={13}
                                      className="text-gray-400"
                                    />
                                    {task?.sender_number || "-"}
                                  </div>
                                </div>
                              </td>

                              {/* Receiver */}
                              <td className="px-4 py-3">
                                <div className="space-y-1">
                                  <div className="text-sm font-medium text-gray-900">
                                    {task?.receiver_name || "-"}
                                  </div>

                                  <div className="flex items-center gap-1.5 text-xs text-gray-600">
                                    <Phone
                                      size={13}
                                      className="text-gray-400"
                                    />
                                    {task?.receiver_number || "-"}
                                  </div>
                                </div>
                              </td>

                              {/* Trip */}
                              <td className="px-4 py-3">
                                <div className="space-y-1.5 text-xs text-gray-700">
                                  <div>
                                    <span className="font-medium">
                                      Distance:
                                    </span>{" "}
                                    {task?.distance
                                      ? `${task.distance} km`
                                      : "-"}
                                  </div>

                                  <div>
                                    <span className="font-medium">
                                      Duration:
                                    </span>{" "}
                                    {formatTaskDuration(task?.duration)}
                                  </div>

                                  <div
                                    className="max-w-[220px] truncate text-[11px] text-gray-500"
                                    title={`Pickup: ${task?.pickup_latitude || "-"}, ${
                                      task?.pickup_longitude || "-"
                                    }`}
                                  >
                                    Pickup: {task?.pickup_latitude || "-"},{" "}
                                    {task?.pickup_longitude || "-"}
                                  </div>

                                  <div
                                    className="max-w-[220px] truncate text-[11px] text-gray-500"
                                    title={`Drop: ${task?.dropoff_latitude || "-"}, ${
                                      task?.dropoff_longtidue ||
                                      task?.dropoff_longitude ||
                                      "-"
                                    }`}
                                  >
                                    Drop: {task?.dropoff_latitude || "-"},{" "}
                                    {task?.dropoff_longtidue ||
                                      task?.dropoff_longitude ||
                                      "-"}
                                  </div>
                                </div>
                              </td>

                              {/* Fare */}
                              <td className="px-4 py-3">
                                <div className="text-sm font-semibold text-green-700">
                                  {formatAmount(task?.fare)}
                                </div>
                              </td>

                              {/* Status */}
                              <td className="px-4 py-3">
                                <div className="space-y-2">
                                  <span
                                    className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${getTaskStatusColor(
                                      task?.status,
                                    )}`}
                                  >
                                    {task?.status || "-"}
                                  </span>

                                  {task?.cancel_reason && (
                                    <div
                                      className="max-w-[180px] text-xs text-red-600"
                                      title={task.cancel_reason}
                                    >
                                      {task.cancel_reason}
                                    </div>
                                  )}
                                </div>
                              </td>

                              {/* Driver */}
                              {/* Driver */}
                              <td className="px-4 py-3">
                                <div className="space-y-1.5">
                                  <span
                                    className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${
                                      driverAssigned
                                        ? "bg-green-100 text-green-700"
                                        : "bg-gray-100 text-gray-600"
                                    }`}
                                  >
                                    {task?.driver_status || "unassigned"}
                                  </span>

                                  <div className="text-xs text-gray-600">
                                    Driver ID:{" "}
                                    {task?.driver_id || "Not assigned"}
                                  </div>

                                  {assignedDriver && (
                                    <>
                                      <div className="text-xs font-medium text-gray-800">
                                        {assignedDriver?.fullName ||
                                          assignedDriver?.name ||
                                          assignedDriver?.username ||
                                          assignedDriver?.driverId ||
                                          "-"}
                                      </div>

                                      <span
                                        className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium ${
                                          isActiveForPacker
                                            ? "bg-orange-100 text-orange-700"
                                            : "bg-gray-100 text-gray-600"
                                        }`}
                                      >
                                        {isActiveForPacker
                                          ? "Active Packer"
                                          : "Not Packer"}
                                      </span>

                                      <div className="text-[11px] text-gray-500">
                                        Packer Team ID:{" "}
                                        {packerTeamId > 0
                                          ? packerTeamId
                                          : "Not assigned"}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </td>

                              {/* Created */}
                              <td className="px-4 py-3">
                                <div className="space-y-1 text-xs text-gray-600">
                                  <div>{formatDateTime(task?.created_on)}</div>

                                  <div>
                                    Pickup:{" "}
                                    {task?.pickup_time
                                      ? formatDateTime(task.pickup_time)
                                      : "-"}
                                  </div>

                                  <div>
                                    Drop:{" "}
                                    {task?.dropoff_time
                                      ? formatDateTime(task.dropoff_time)
                                      : "-"}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan={8}
                            className="px-4 py-12 text-center text-sm text-gray-500"
                          >
                            No packer tasks found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}
      </>

      {renderModals()}
      <Dialog.Root open={statusConfirmOpen} onOpenChange={setStatusConfirmOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />

          <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[92%] max-w-md -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-2xl bg-white shadow-xl">
            <div className="border-b bg-gradient-to-r from-orange-50 to-white px-5 py-4">
              <Dialog.Title className="flex items-center gap-2 text-base font-semibold text-gray-900">
                <AlertTriangle
                  size={18}
                  className={
                    statusDriver?.status === "active"
                      ? "text-red-600"
                      : "text-green-600"
                  }
                />
                {statusDriver?.status === "active"
                  ? "Deactivate Driver"
                  : "Activate Driver"}
              </Dialog.Title>
            </div>

            <div className="px-5 py-4">
              <p className="text-sm text-gray-700">
                Are you sure you want to{" "}
                <span className="font-semibold">
                  {statusDriver?.status === "active"
                    ? "deactivate"
                    : "activate"}
                </span>{" "}
                this driver?
              </p>

              <div className="mt-3 rounded-xl border bg-gray-50 p-3 text-sm">
                <div className="font-semibold text-gray-900">
                  {statusDriver?.fullName || statusDriver?.username || "Driver"}
                </div>

                <div className="text-xs text-gray-500">
                  {statusDriver?.driverId || "-"} • Current Status:{" "}
                  {statusDriver?.status || "-"}
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-2 border-t px-5 py-4">
              <button
                className="rounded-lg border px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                onClick={() => {
                  setStatusConfirmOpen(false);
                  setStatusDriver(null);
                }}
                disabled={statusSubmitting}
              >
                Cancel
              </button>

              <button
                className={`rounded-lg px-4 py-2 text-sm font-medium text-white disabled:opacity-60 ${
                  statusDriver?.status === "active"
                    ? "bg-red-600 hover:bg-red-700"
                    : "bg-green-600 hover:bg-green-700"
                }`}
                disabled={statusSubmitting}
                onClick={async () => {
                  if (!statusDriver) return;

                  setStatusSubmitting(true);
                  const success =
                    await deactivateActivateDriverApi(statusDriver);
                  setStatusSubmitting(false);

                  if (success) {
                    setStatusConfirmOpen(false);
                    setStatusDriver(null);
                  }
                }}
              >
                {statusSubmitting
                  ? "Updating..."
                  : statusDriver?.status === "active"
                    ? "Deactivate"
                    : "Activate"}
              </button>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>

      <PackerTaskConfigModal
        open={packerTaskConfigOpen}
        onOpenChange={setPackerTaskConfigOpen}
        drivers={drivers}
        getPackerTaskConfig={getPackerTaskConfig}
        savePackerTaskConfig={savePackerTaskConfig}
        onSuccess={() => {}}
      />
    </div>
  );
}
